import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, UsersManagementReducer, UsersManagementState } from './users-management-reducer';
import { PaginationResponse } from '../../../model/base/response/pagination-response';
import { IUserListResponse } from '../../../model/security/response/user-list-response';
import { IListUsersRequest } from '../../../model/security/request/list-users-request';
import { ICreateUserRequest } from '../../../model/security/request/create-user-request';

const UsersManagementContext = createContext<UsersManagementState | undefined>(undefined);
const UsersManagementContextDispatchContext = createContext({} as any);

const UsersManagementProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(UsersManagementReducer, {
        usersPagedResponse: {
            items: [] as IUserListResponse[],
            page: 0,
            pageSize: 50,
            pageCount: 0,
            totalRecords: 0
        } as PaginationResponse<IUserListResponse>,
        usersPagedRequest: {
            page: 0,
            pageSize: 50,
            email: "",
            name: "",
            isActive: undefined
        } as IListUsersRequest,
        selectedUser: null,
        isLoadingData: false,
        isLoadingUser: false,
        isDrawerOpen: false,
        isEditing: false,
        userForm: {
            email: '',
            password: '',
            accessGroupId: 3,
            name: '',
            documentNumber: '',
            isActive: true,
            personEntityIds: [],
            personCompanyIds: [],
            entityAccesses: [],
            confirmPassword: ''
        } as ICreateUserRequest,
        accessGroups: [],
        accessProfiles: [],
        personEntities: [],
        isLoadingLookups: false,
        passwordResetDialog: {
            open: false,
            userName: '',
            userEmail: '',
            newPassword: ''
        }
    } as UsersManagementState);

    return (
        <UsersManagementContext.Provider value={state}>
            <UsersManagementContextDispatchContext.Provider value={dispatch}>
                {children}
            </UsersManagementContextDispatchContext.Provider>
        </UsersManagementContext.Provider>
    );
};

const useUsersManagementState = () => {
    const context = useContext(UsersManagementContext);
    if (context === undefined) {
        throw new Error('useUsersManagementState must be used within a UsersManagementProvider');
    }
    return context;
};

const useUsersManagementDispatch = () => {
    const context = useContext(UsersManagementContextDispatchContext);
    if (context === undefined) {
        throw new Error('useUsersManagementDispatch must be used within a UsersManagementProvider');
    }
    return context;
};

export { UsersManagementProvider, useUsersManagementDispatch, useUsersManagementState, ACTION_TYPES };
